import { showError } from '@lib/utils';
import { authService } from '@services/index';
import {
  Button, Form, Input, message
} from 'antd';
import Link from 'next/link';
import { useState } from 'react';
import useCountdown from 'src/hooks/use-countdown';
import { IForgot } from 'src/interfaces';
import style from './forgot-password-form.module.scss';

// Password / asterisk badge icon
function PasswordIcon() {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="2" y="7" width="20" height="13" rx="2" ry="2" />
      <circle cx="7" cy="13.5" r="1.5" fill="#fff" />
      <circle cx="12" cy="13.5" r="1.5" fill="#fff" />
      <circle cx="17" cy="13.5" r="1.5" fill="#fff" />
    </svg>
  );
}

function ForgotPasswordForm() {
  const [submitting, setSubmitting] = useState(false);
  const numCountdown = 60;
  const { countTime, setCountdown } = useCountdown();

  const handleReset = async (data: IForgot) => {
    try {
      setSubmitting(true);
      await authService.resetPassword({ ...data });
      message.success('An email has been sent to you to reset your password');
      setCountdown(numCountdown);
    } catch (e) {
      showError(e);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={style['forgot-page']}>
      <div className={style['forgot-wrapper']}>
        <div className={style['forgot-card']}>

          {/* Badge icon — top right */}
          <div className={style.badge} aria-hidden="true">
            <PasswordIcon />
          </div>

          {/* Title */}
          <h1 className={style.title}>Reset Password</h1>

          {/* Form */}
          <Form
            name="forgot-form"
            className={style.form}
            onFinish={handleReset}
          >
            <Form.Item
              name="email"
              validateTrigger={['onChange', 'onBlur']}
              rules={[
                { type: 'email', message: 'Invalid email format' },
                { required: true, message: 'Please enter your e-mail' }
              ]}
            >
              <Input
                className={style.input}
                placeholder="Enter your email address"
                size="large"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className={style['form-button']}
                disabled={submitting || countTime > 0}
                loading={submitting || countTime > 0}
                size="large"
                block
              >
                {countTime > 0 ? `Resend in ${countTime}s` : 'Send'}
              </Button>
            </Form.Item>
          </Form>
          <div className={style.links}>
            <p>
              Have an account already?&nbsp;
              <Link href="/auth/login">Log in here.</Link>
            </p>
            <p>
              Don&apos;t have an account yet?&nbsp;
              <Link href="/auth/register">Sign up here.</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordForm;
